"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));

var _actionError = _interopRequireDefault(require("./actionError"));

var _noValidation = _interopRequireDefault(require("./noValidation"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Action = function Action() {
  var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var nsValidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _noValidation["default"];
  return function () {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nsValidate;

    var actionCreator = function actionCreator(payload) {
      var shouldValidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var action = {
        type: actionCreator.type,
        payload: payload
      };

      if (!shouldValidate) {
        return action;
      }

      var isValid = validate(action);
      return isValid ? action : (0, _actionError["default"])(action, validate.errors);
    };

    actionCreator.type = "".concat(namespace, "/").concat((0, _snakeCase["default"])(name).toUpperCase());
    actionCreator.validate = validate;
    return actionCreator;
  };
};

var _default = Action;
exports["default"] = _default;